import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createPinia } from 'pinia'
import { vSafeHtml } from '@/directives/safeHtml';
import { installApexChartsBenignErrorGuards } from "@/utils/apexChartsBenign";
import {
    clearChunkReloadAttempt,
    installChunkLoadUnhandledRejectionGuard,
} from "@/utils/chunkLoadError";
import { createHead } from "@vueuse/head";
import i18n from "./i18n";
import appSetting from "./app-setting";
import {
    bindAppForDeferredPlugins,
    ensureFullAppPlugins,
    ensureSalesPlugins,
    isSalesInscricaoPath,
} from "@/bootstrap/appBoot";
import { initMetaPixel } from "@/services/metaPixel";
import { initMarketingAttribution } from "@/services/marketingAttribution";

clearChunkReloadAttempt();
installChunkLoadUnhandledRejectionGuard();
installApexChartsBenignErrorGuards();

// Pixel + attribution só no funil público /inscricao/* (stub fbq síncrono; fbevents.js async).
if (isSalesInscricaoPath()) {
    initMetaPixel();
    initMarketingAttribution();
}

function deferNonCriticalInit(fn, timeout = 3000) {
    if (typeof window === 'undefined') return;
    if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => fn(), { timeout });
        return;
    }
    setTimeout(fn, Math.min(timeout, 1500));
}

const pinia = createPinia()
const app = createApp(App);
const head = createHead();

bindAppForDeferredPlugins(app);
window.$appSetting = appSetting;
window.$appSetting.init();

app
.use(store)
.use(pinia)
.use(router)
.use(i18n)
.use(head)
.directive('safe-html', vSafeHtml);

// Landing /inscricao: monta na hora — SweetAlert/Bootstrap sobem no idle ou no checkout.
const boot = isSalesInscricaoPath()
    ? Promise.resolve()
    : ensureFullAppPlugins();

// Evita flash do sidebar/menu em rotas autenticadas antes do guard resolver a sessão.
if (!isSalesInscricaoPath()) {
    store.commit('setLoading', true);
} else {
    deferNonCriticalInit(() => {
        ensureSalesPlugins().catch(() => {});
    }, 4000);
}

boot.finally(() => {
    app.mount("#app");
});

deferNonCriticalInit(() => {
    if (import.meta.env.PROD) {
        import("@sentry/vue").then((Sentry) => {
            import("@/utils/sentryFilters").then(({ sentryBeforeSend }) => {
                Sentry.init({
                    app,
                    dsn: "https://1e3a147a23118b1337f06a513891e5e0@o4511362086928384.ingest.us.sentry.io/4511362144862208",
                    sendDefaultPii: true,
                    beforeSend: sentryBeforeSend,
                });
            }).catch(() => {});
        }).catch(() => {});
    }
}, 4000);

if (typeof localStorage !== 'undefined' && localStorage.getItem('auth_token')) {
  router.isReady().then(() => {
    if (isSalesInscricaoPath()) return;
    store.dispatch('auth/checkAuth').catch(() => {
      // Falha não-401 na hidratação; 401 retorna null e checkAuth já limpou token inválido.
    });
  });
}
